<template>
  <div>
    <div class="px-6 pt-6 cursor-pointer w-full md:w-2/3 mx-auto">
      <span class="flex text-zt-dark-400" @click="
      goBack()
        " data-vs-button="toPendingApproval">
        <zt-icon name="angle-left" class="pb-2 mt-1 pr-1" />
        <p>Volver</p>
      </span>
    </div>
    <div class="p-6 cursor-pointer w-full md:w-2/3 mx-auto flex justify-between items-center">
      <h1 class="font-normal text-3xl leading-8 text-zt-primary-200">
        Anticipos de sueldo
      </h1>
      <div class="inline-block">
        <zt-button icon="plus-circle" @click="$router.push({
          name: 'requestSalaryAdvances', query: {
            isManager: 'false'
          }
        })">Solicitar anticipo</zt-button>
      </div>
    </div>
    <div class="mt-8 md:w-1/2 mx-auto" v-if="!showTable">
      <loader v-if="loading" />
      <div class="bg-white rounded border border-gray-300 flex w-full">
        <!-- Mostrar SVG si no hay anticipos -->
        <template>
          <div class="px-6 pb-2">
            <DesertSVG />
          </div>
          <div class="text-center md:text-left mt-4 ml-4">
            <h1 class="text-2xl font-semibold text-gray-700">
              {{ $t("message.dashboard.notFound.title") }}
            </h1>
            <h2 class="text-gray-600 font-medium py-2">
              {{ $t("message.dashboard.notFound.description") }}
            </h2>
          </div>
        </template>
        <!-- Mostrar Tabla si hay anticipos -->
        
      </div>
    </div>
    <div class="mt-8 md:w-2/3 mx-auto bg-white rounded border border-gray-300 flex relative" v-else>
      <loader v-if="loading" />
      <zt-data-table :columns="columns" :rows="data" table-name="Solicitudes de Anticipos"   :config="{ pagination: { use: false } }">
        <template #status="{ item }">
          <span class="inline-flex items-center py-1 px-3 rounded-full text-xs" :class="getChipClass(item.status)">
            <zt-icon :name="getIconName(item.status)" class="mr-1" />
            {{ item.status }}
          </span>
        </template>
      </zt-data-table>
    </div>

  </div>
</template>

<script>
import DesertSVG from "@/components/commons/Illustrations/graphicSVG/DesertSVG";
import Payroll from "@/apiClient/Payroll";
import Loader from '@/modules/Auth/components/loader'

export default {
  components: {
    DesertSVG, Loader
  },
  data() {
    return {
      showTable: true,
      payroll: Payroll,
      columns: [
        { dataField: 'date', name: 'Fecha', sortable: false },
        { dataField: 'amount', name: 'Monto', sortable: false },
        { dataField: 'description', name: 'Descripción', sortable: false },
        { dataField: 'plannedDate', name: 'Fecha estimada', sortable: false },
        { dataField: 'status', name: 'Estado', sortable: false }
      ],
      pagination: {
        page: 0,
        totalItems: 10,
        rowsPerPage: 0,
      },
      data: [],
      loading: true
    }
  },
  created() {
    this.loading = true;
    this.getSalaryAdvances();
    
  },
  methods: {
    getSalaryAdvances() {
      const { page, rowsPerPage } = this.pagination
      this.loading = true;
      this.payroll = new Payroll();
      this.payroll.getSalaryAdvances(rowsPerPage, page).then((response) => {
        this.pagination.totalItems = response.data.pagination.total;
        this.data = response.data.results.data.map((item, index) => ({
          id: index + 1,
          date: this.formatDate(item.date),
          amount: `$${item.amount.toLocaleString()}`,
          requestedAmount: `$${item.amount.toLocaleString()}`,
          plannedDate: this.formatDatee(item.planned_date),
          description: item.description,
          status: this.formatStatus(item.status)
        }));
      });
      this.loading = false;
    },
    goBack() {
      this.hasHistory() ? this.$router.go(-1) : this.$router.push('/')
    },
    hasHistory() {
      return window.history.length > 2
    },
    formatDatee(dateStr) {
      const date = new Date(dateStr);
      const options = { month: 'long' };
      const month = new Intl.DateTimeFormat('es-ES', options)
        .format(date)
        .charAt(0)
        .toUpperCase() + new Intl.DateTimeFormat('es-ES', options)
        .format(date)
        .slice(1);
      const year = date.getFullYear();
      return `${month} ${year}`;
    },
    formatDate(dateStr) {
      const date = new Date(dateStr);
      const day = String(date.getDate()).padStart(2, '0');
      const month = String(date.getMonth() + 1).padStart(2, '0');
      const year = date.getFullYear();
      return `${day}/${month}/${year}`;
    },
    formatStatus(status) {
      const statusMapping = {
        1: 'PENDIENTE',
        2: 'APROBADA',
        3: 'RECHAZADA'
      };
      return statusMapping[status];
    },
    getChipClass(status) {
      const chipClasses = {
        'PENDIENTE': 'bg-orange-200 text-orange-800 border border-orange-500',
        'APROBADA': 'bg-green-200 text-green-800 border border-green-500',
        'RECHAZADA': 'bg-red-200 text-red-800 border border-red-500',
      };
      return chipClasses[status] || 'bg-gray-200 text-gray-800';
    },
    getIconName(status) {
      const iconNames = {
        'PENDIENTE': 'clock',
        'APROBADA': 'check',
        'RECHAZADA': 'times',
      };
      return iconNames[status] || 'default-icon';
    }
  }
};
</script>

<style lang="scss" scoped>
.chip-pendiente {
  background-color: #FFF7ED;
  color: #D97706;
  border: 1px solid #FB923C;
}

.chip-aprobada {
  background-color: #E6FFFA;
  color: #059669;
  border: 1px solid #10B981;
}

.chip-rechazada {
  background-color: #FFE4E6;
  color: #D32F2F;
  border: 1px solid #EF4444;
}
</style>